import { useState } from 'react';
import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError('');

    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      setSubmitting(false);
      form.reset();
      setTimeout(() => setFormStatus('idle'), 4000);
      return;
    }

    try {
      const formData = new FormData(form);
      if (honeypotEl) formData.delete('website_alt');

      const res = await fetch('https://readdy.ai/api/form/d9li0168mbnljin59dn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 4000);
      } else {
        throw new Error(serverMsg.includes('spam') || serverMsg.includes('form data is spam')
          ? '提交失败，请稍后重试'
          : serverMsg || '提交失败，请稍后重试');
      }
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : '提交失败，请稍后重试';
      setFormError(msg);
      setFormStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">{contactData.title}</h2>
          <p className="text-foreground-500 text-sm md:text-base">{contactData.subtitle}</p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2 flex flex-col gap-5">
              <div className="p-5 rounded-xl bg-background-100 border border-background-200">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </span>
                  <div>
                    <div className="text-xs text-foreground-400">投稿邮箱</div>
                    <div className="text-sm text-foreground-800 font-medium">{contactData.email}</div>
                  </div>
                </div>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-wechat-line text-accent-600 text-lg"></i>
                  </span>
                  <div>
                    <div className="text-xs text-foreground-400">微信公众号</div>
                    <div className="text-sm text-foreground-800 font-medium">{contactData.wechat}</div>
                  </div>
                </div>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200 flex-1">
                <p className="text-foreground-600 text-sm leading-relaxed">
                  我们承诺对所有爆料人信息进行严格保密。您的每一次投稿，都可能成为推动行业改变的力量。期待您的线索。
                </p>
              </div>
            </div>

            <div className="lg:col-span-3">
              <form onSubmit={handleSubmit} data-readdy-form className="p-6 rounded-xl bg-background-100 border border-background-200">
                {formStatus === 'success' && (
                  <div className="mb-4 p-3 rounded-lg bg-accent-100 text-accent-700 text-sm font-medium">
                    <i className="ri-checkbox-circle-fill mr-1.5"></i> 投稿已收到！感谢您的爆料，我们的编辑会尽快处理。
                  </div>
                )}
                {formStatus === 'error' && formError && (
                  <div className="mb-4 p-3 rounded-lg bg-primary-100 text-primary-700 text-sm font-medium">
                    <i className="ri-error-warning-fill mr-1.5"></i> {formError}
                  </div>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm text-foreground-700 mb-1.5">您的昵称</label>
                    <input
                      type="text"
                      name="nickname"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="如何称呼您"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-foreground-700 mb-1.5">电子邮箱</label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm text-foreground-700 mb-1.5">爆料主题</label>
                  <input
                    type="text"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="简要描述您要爆料的内容"
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm text-foreground-700 mb-1.5">详细内容</label>
                  <textarea
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请详细描述事件经过，包括时间、地点、人物等信息（限500字）"
                  ></textarea>
                  <div className="text-xs text-foreground-400 mt-1 text-right">最多500字</div>
                </div>

                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full px-8 py-3 bg-primary-500 text-background-50 font-bold text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {submitting ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-loader-4-line animate-spin"></i> 提交中...
                    </span>
                  ) : (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-send-plane-fill"></i> 提交爆料
                    </span>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}